import React from "react";
import { CouponUserState, UserCardState } from "../../../interface/interface";

type Props = {
  data: UserCardState;
  all: boolean;
  CheckUser: (id: string, name: string, email: string, lid: string) => void;
  checkdata: CouponUserState[];
};

function Check({
  data: { login_nm, usr_id, usr_email, login_id },
  all,
  CheckUser,
  checkdata,
}: Props) {
  return (
    <div
      className="box"
      onClick={() => {
        CheckUser(usr_id, login_nm, usr_email, login_id);
      }}
    >
      <div className="check">
        {checkdata.findIndex((item) => item.usr_id === usr_id) > -1 || all ? (
          <img src="/assets/common/check.svg" alt="" />
        ) : undefined}
      </div>
      <div className="name">{login_nm}</div>
      <div className="id">{login_id}</div>
      <div className="email">{usr_email}</div>
    </div>
  );
}

export default Check;
